import React from 'react';
import styles from './NuevoSistema.module.css';
import { Link } from 'react-router-dom';

const NuevoSistema = () => {
    return (
        <section className={`${styles.section} section`}>
            <div className={`container-lg flex flexRow space alignCenter ${styles.nuevoSistema}`}>
                <div className={styles.col60}>
                    <p className={styles.eyebrow}>Nuevos Equipos</p>
                    <h2>
                        Ahora te instalamos equipos inalámbricos de última generación
                    </h2>
                    <p>
                        Sensores de movimiento, de apertura, botones antipánico, cámaras HD de última tecnología para que tengas protección de verdad
                    </p>
                    <Link to="/cotizador" className="btn">Cotizar Alarma</Link>
                </div>
                <div className={styles.col40}>
                    <img
                        src="src/smart.webp"
                        alt="Sistema de alarma inteligente ADT"
                        width="768"
                        height="768"
                        loading="lazy"
                        decoding="async"
                    />
                </div>
            </div>
        </section>
    );
};

export default NuevoSistema;
